import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { InternationalizationComponent } from './internationalization/internationalization.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { LanguageGuard } from 'src/security/language.guard';
// import { SiteMapTestEnvComponent } from './site-map-test-env/site-map-test-env.component';

const routes: Routes = [
  // { path: '', redirectTo: `${localStorage.Language ? localStorage.Language : 'ar'}/home`, pathMatch: 'full' },
  { path: 'not-found', component: NotFoundComponent },
  {
    path: ':languageCode',
    component: InternationalizationComponent,
    canActivate: [LanguageGuard],
    children: [
      // { path: '', redirectTo: `home`, pathMatch: 'full' },
      // { path: 'site-map', component: SiteMapTestEnvComponent },
      {
        path: 'about-us', loadChildren: () => import('./about-us/about-us.module').then(m => m.AboutUsModule),
        data: { title: { en: 'iHospital | About Us', ar: 'iHospital | من نحن' } }
      },
      {
        path: 'blog',
        loadChildren: () =>
          import('./blog/blog.module').then((m) => m.BlogModule),
        data: { title: { en: 'iHospital | Medical Blogs', ar: 'iHospital | مقالات طبية' } }
      },
      {
        path: 'patient-profile',
        loadChildren: () =>
          import('./patient-profile/patient-profile.module').then((m) => m.PatientProfileModule),
        data: { title: { en: 'iHospital', ar: 'iHospital' } }
      },
      {
        path: 'home',
        loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
        data: { title: { en: 'Best Doctors in Jordan - Book Online | iHospital', ar: 'أفضل أطباء الأردن - احجز اونلاين | iHospital' } }
      },
      {
        path: 'doctor',
        loadChildren: () =>
          import('./doctor/doctor.module').then((m) => m.DoctorModule),
      },
      {
        path: 'Tebgram',
        loadChildren: () =>
          import('./doctor/doctor-social/doctor-social.module').then((m) => m.DoctorSocialModule),
        data: { title: { en: 'iHospital | Tebgram', ar: 'iHospital | طبجرام' } }
      },
      {
        path: 'inbox',
        loadChildren: () =>
          import('./doctor/inbox/inbox.module').then((m) => m.InboxModule),
        data: { title: { en: 'iHospital', ar: 'iHospital' } }
      },
      {
        path: 'chat',
        loadChildren: () =>
          import('./private-chat/private-chat/private-chat.module').then((m) => m.PrivateChatModule),
        data: { title: { en: 'iHospital', ar: 'iHospital' } }
      },
      {
        path: 'become-doctor',
        loadChildren: () =>
          import('./become-doctor/become-doctor.module').then((m) => m.BecomeDoctorModule),
        data: { title: { en: 'iHospital', ar: 'iHospital' } }
      },
      {
        path: 'terms',
        loadChildren: () =>
          import('./common/terms/terms.module').then((m) => m.TermsModule),
        data: { title: { en: 'iHospital | Terms And Conditions', ar: 'iHospital |  الأحكام والشروط' } }
      },
      {
        path: 'patients',
        loadChildren: () =>
          import('./patients/patients.module').then((m) => m.PatientsModule),
        data: { title: { en: 'iHospital', ar: 'iHospital' } }
      },
      {
        path: 'meet',
        loadChildren: () =>
          import('./pat-inv-com/pat-inv-com.module').then((m) => m.PatInvComModule),
        data: { title: { en: 'iHospital', ar: 'iHospital' } }
      },
      {
        path: 'search-doctor/:specialty/:location',
        loadChildren: () =>
          import('./search-doctor/search-doctor.module').then((m) => m.SearchDoctorModule),
        // data: { title: { en: 'Best specialty doctor in area | Book now for free | iHospital', ar: 'iHospital | أفضل دكتور تخصص في المنطقة | حجز مجاني - تأكيد الحجز فورياً' } }
      },
      {
        path: 'search',
        loadChildren: () =>
          import('./search/search.module').then((m) => m.SearchModule),
      },
      {
        path: 'search/:specialty',
        loadChildren: () =>
          import('./search/search.module').then((m) => m.SearchModule),
      },
      {
        path: 'search/:specialty/:country',
        loadChildren: () =>
          import('./search/search.module').then((m) => m.SearchModule),
      },
      {
        path: 'search/:specialty/:country/:city',
        loadChildren: () =>
          import('./search/search.module').then((m) => m.SearchModule),
      },
      {
        path: 'search/:specialty/:country/:city/:area',
        loadChildren: () =>
          import('./search/search.module').then((m) => m.SearchModule),
      },
      {
        path: 'search/:specialty/:country/:city/:area/:insuranceCompany',
        loadChildren: () =>
          import('./search/search.module').then((m) => m.SearchModule),
      },
      {
        path: 'doctor-profile/:id',
        loadChildren: () =>
          import('./patients/doctor-profile/doctor-profile.module').then(
            (m) => m.DoctorProfileModule
          )
      },
      {
        path: 'booking',
        loadChildren: () =>
          import('./patients/booking/booking.module').then((m) => m.BookingModule),
        data: { title: { en: 'iHospital', ar: 'iHospital' } }
      },
      {
        path: 'visit-details/:visitId',
        loadChildren: () =>
          import('./visit-details/visit-details.module').then((m) => m.VisitDetailsModule),
        data: { title: { en: 'iHospital', ar: 'iHospital' } }
      },
      {
        path: 'blog-details/:id',
        loadChildren: () =>
          import('./blog-details/blog-details.module').then((m) => m.BlogDetailsModule),
      },
      {
        path: 'service-details/:id',
        loadChildren: () =>
          import('./service-details/service-details.module').then((m) => m.ServiceDetailsModule),
      },
      {
        path: 'login-page',
        loadChildren: () =>
          import('./login/login.module').then((m) => m.LoginModule),
        data: { title: { en: 'iHospital | Login', ar: 'iHospital |  تسجيل الدخول' } }
      },
      {
        path: 'forgot-password',
        loadChildren: () =>
          import('./forgot-password/forgot-password.module').then((m) => m.ForgotPasswordModule),
        data: { title: { en: 'iHospital', ar: 'iHospital' } }
      },
      {
        path: 'Register',
        loadChildren: () =>
          import('./register/register.module').then((m) => m.RegisterModule),
        data: { title: { en: 'iHospital | Register', ar: 'iHospital |  انشاء حساب' } }
      },
      {
        path: 'video-call',
        loadChildren: () =>
          import('./videocall/videocall.module').then((m) => m.VideocallModule),
        data: { title: { en: 'iHospital', ar: 'iHospital' } }
      },
      {
        path: 'inform',
        loadChildren: () =>
          import('./payment&rate/rate-payment.module').then((m) => m.RatePaymentModule),
        data: { title: { en: 'iHospital', ar: 'iHospital' } }
      },
      // { path: '**', redirectTo: '404' }
      { path: '**', pathMatch: 'full', component: NotFoundComponent },
      // { path: '**', redirectTo: 'home', pathMatch: 'full' },
    ]
  },
  // { path: '**', redirectTo: `${localStorage.Language ? localStorage.Language : 'ar'}/home`, pathMatch: 'full' },

  // InternationalizationComponent now have a guard and the guard is ar/en else will go to 404 *****
  // { path: '**', redirectTo: '404' }
  // { path: '**', pathMatch: 'full', component: NotFoundComponent },

  // {
  //   path: '**',
  //   loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
  // },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      // preloadingStrategy: PreloadAllModules,
      relativeLinkResolution: 'legacy',
      initialNavigation: 'enabledBlocking'
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
